<template>
  <div class="page-container">
    <CompanyHeader :company="currentCompany" />
    <div class="body__container">
      <div class="body__container--carousel">
        <div class="carousel-list" v-if="currentStep === 'department'">
          <DepartmentCard
            v-for="department in departments"
            :key="department.id_setor"
            :selected="selectedDepartment === department.id_setor"
            :department="department"
            @click.native="handleDepartmentClick(department.id_setor)"
          />
        </div>

        <div v-else class="form-container">
          <div class="form-container--input">
            <input
              type="text"
              placeholder="Digita aqui o seu nome"
              class="input-field"
              v-model="name"
              @focus="showKeyboard = true"
            />
          </div>
          <div class="form-container--input">
            <select
              placeholder="Selecione o motivo da sua visita"
              class="input-field"
              v-model="selectedReason"
            >
              <option
                v-for="reason in reasons"
                :key="reason.id_motivo"
                :value="reason.id_motivo"
              >
                <p>{{ reason.motivo }}</p>
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="body__container--card">
        <div class="thin-line" />
        <p>
          {{ helpText }}
        </p>
      </div>
      <div class="body__container--actions">
        <!-- <BackButton /> -->
        <button
          v-if="
            (selectedDepartment !== null && currentStep === 'department') ||
            (name !== '' && currentStep === 'reason')
          "
          @click="onNext"
          class="next-btn"
        >
          Próximo
        </button>
      </div>
    </div>
    <Keyboard
      v-if="showKeyboard"
      v-model="name"
      @enter="handleEnter"
      @close="showKeyboard = false"
    />
  </div>
</template>

<script>
import CompanyHeader from "../components/Departments/CompanyHeader.vue";
import DepartmentCard from "../components/Departments/DepartmentCard.vue";
import config from "../config";
import CompanyService from "../services/CompanyService";
import BackButton from "../components/BackButton.vue";
import Keyboard from "../components/Keyboard.vue";

export default {
  data() {
    return {
      imgPath: config.URL_IMAGE,
      companyId: this.$route.params.companyId,
      companyService: new CompanyService(),
      departments: [],
      companies: [],
      currentCompany: {},
      selectedDepartment:
        Number(this.$store.state.schedule.department) ? this.$store.state.schedule.department
          : null,
      steps: ["department", "reason"],
      currentStep: "department",
      selectedReason: this.$store.state.schedule.reason || null,
      reasons: [],
      name: this.$store.state.schedule.name || "",
      showKeyboard: false,
    };
  },
  components: {
    CompanyHeader,
    DepartmentCard,
    BackButton,
    Keyboard,
  },
  methods: {
    async getDepartments() {
      await this.companyService
        .getDepartments(this.companyId)
        .then((response) => {
          this.departments = response;
        })
        .catch((error) => {
          console.error("Error fetching departments:", error);
        });
    },
    async getCompanies() {
      await this.companyService
        .getCompanies()
        .then((response) => {
          this.companies = response.data;

          this.currentCompany = this.companies.find(
            (company) => company.id_instituicao === this.companyId
          );
        })
        .catch((error) => {
          console.error("Error fetching companies:", error);
        });
    },
    async getReasons() {
      await this.companyService
        .getVisitorsReasons()
        .then((response) => {
          this.reasons = response;
          this.selectedReason = this.reasons[0].id_motivo;
        })
        .catch((error) => {
          console.error("Error fetching reasons:", error);
        });
    },
    handleDepartmentClick(departmentId) {
      this.selectedDepartment !== departmentId
        ? (this.selectedDepartment = departmentId)
        : (this.selectedDepartment = null);
    },
    handleRedirect() {
      this.$router.push({ name: "camera", params: { id: this.companyId } });
    },
    onNext() {
      if (this.currentStep === "department") {
        this.currentStep = "reason";
      } else if (this.currentStep === "reason") {
        this.setNameAndReason();
        this.handleRedirect();
      }
    },
    setNameAndReason() {
      this.$store.commit("setScheduleCompany", this.currentCompany);
      this.$store.commit("setScheduleDepartment", this.selectedDepartment);
      this.$store.commit("setScheduleReason", this.selectedReason);
      this.$store.commit("setScheduleName", this.name);
    },
    goBack() {
      if (this.currentStep === "reason") {
        this.currentStep = "department";
      } else if (this.currentStep === "department") {
        this.$router.push({ name: "non-scheduled" });
      }
    },
    handleEnter(){
      this.showKeyboard = false;
      this.onNext();
    }
  },
  computed: {
    helpText() {
      return this.currentStep === "department"
        ? "Selecione ao lado o setor a qual deseja tratar."
        : "Por favor se identifique ao lado, preencha com seu nome e objetivo.";
    },
  },
  async mounted() {
    this.$store.commit('setIsLoading', true)
    await this.getDepartments();
    await this.getCompanies();
    await this.getReasons();
    this.$store.commit('setIsLoading', false)
  },
};
</script>
<style scoped>
.page-container {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}

.body__container {
  height: 70%;
  min-height: 70%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.body__container--card {
  background-color: #ffffff;
  width: 100%;
  height: 110%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding: 70px 60px;

  p {
    color: #838383;
    text-align: justify;
    width: 25%;
    font-size: 1.2vw;
  }
}

.thin-line {
  border-bottom: 2px solid #de3012;
  width: 20%;
  height: 20px;
  display: flex;
  justify-content: start;
  align-items: start;
  margin: 10px 0px;
}

.body__container--carousel {
  /* background-color: #3c3341; */
  width: 55%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0px;
  /* overflow-x: auto; */
}

.carousel-list {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 95%;
  height: 100%;
  max-width: 95%;
  overflow-x: auto;
  gap: 15px;
  padding: 0px 10px;
  scrollbar-width: 10px;
  scrollbar-color: #e7665288 transparent;
  scrollbar-thumb-color: #e76752;
  scrollbar-thumb-border-radius: 10px;
  scrollbar-track-border-radius: 10px;
  scrollbar-width: thin;
}

.next-btn {
  background-color: #e76752;
  border: none;
  color: white;
  font-size: 1.3vw;
  font-weight: medium;
  padding: 10px 30px;
  cursor: pointer;
  border-radius: 3px;
}

.next-btn:hover {
  background-color: #e76752;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
}

.body__container--actions {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 10%;
  padding: 0px 20px;
  position: absolute;
  bottom: 10px;
}

.form-container {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: start;
  align-items: start;
  /* background-color: #ffffff; */
  position: absolute;
}

.form-container--input {
  width: 55%;
  height: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #edf0f8;
  border-left: 8px solid #e76752;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  .input-field {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: medium;
    color: #443B49;
    background-color: #edf0f8;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.145);
    outline: none;
    transition: all 0.3s ease;

    &::placeholder{
      color: #443b4947;
    }

    &:focus {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
      /* transform: scale(1.05); */
      cursor: pointer;
      transition: all 0.3s ease;
    }
  }

  option {
    color: #838383;
    font-size: 1vw;
    font-weight: medium;
  }
}
</style>
